import React from 'react';

interface BasicInfoFieldsProps {
  name: string;
  status: 'draft' | 'active' | 'paused' | 'archived';
  errors: {
    name?: string;
    slug?: string;
  };
  onChange: (field: 'name' | 'status', value: string) => void;
}

const fieldBase =
  'mt-1 block w-full bg-white border rounded-lg px-3 py-2.5 text-sm text-tinta placeholder:text-tinta-soft/70 placeholder:italic focus:outline-none focus:ring-2 transition-colors';

const BasicInfoFields: React.FC<BasicInfoFieldsProps> = ({
  name,
  status,
  errors,
  onChange
}) => {
  return (
    <>
      <div>
        <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
          Nome do Sorteio *
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onChange('name', e.target.value)}
          className={`${fieldBase} ${
            errors.name
              ? 'border-bordo/60 focus:ring-bordo/40 focus:border-bordo'
              : 'border-tinta/15 focus:ring-bordo/40 focus:border-bordo'
          }`}
          placeholder="Ex: Sorteio de Natal"
        />
        {errors.name && (
          <p className="mt-1 text-sm text-bordo italic">{errors.name}</p>
        )}
      </div>

      <div>
        <label className="block text-xs font-bold uppercase tracking-wider text-tinta">
          Status *
        </label>
        <select
          value={status}
          onChange={(e) => onChange('status', e.target.value)}
          className={`${fieldBase} border-tinta/15 focus:ring-bordo/40 focus:border-bordo`}
        >
          <option value="draft">Rascunho</option>
          <option value="active">Ativo</option>
        </select>
        <p className="mt-1 text-xs text-tinta-soft italic">
          {status === 'active' ? 'Visível para participantes' : 'Não visível publicamente'}
        </p>
      </div>
    </>
  );
};

export default BasicInfoFields;
